import React from "react";
import "./VertNavbar.css";
import "./ClubNavbar.css";

import ClubSettingsNavbarElement from "./elements/ClubSettingsNavbarElement";
import LogoNavbarElement from "./elements/LogoNavbarElement";
import UserNavbarElement from "./elements/UserNavbarElement";
import BranchNavbarElement from "./elements/BranchNavbarElement";
import { MainContext } from "../../contexts/MainContext";

export default class ClubNavbar extends React.Component<
  {
    selectedScreen: string;
    showMobile?: boolean;
    hideMobileNav: any;
    clubId: string;
    isAdmin: boolean;
  },
  {}
> {
  static contextType = MainContext;
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div
          className={`nav-background ${
            this.props.showMobile && " show-nav-background"
          }`}
          onClick={this.props.hideMobileNav}
        ></div>
        <nav
          className={`vert-navbar br-navbar ${
            this.props.showMobile && " vert-navbar-mobile"
          }`}
        >
          <LogoNavbarElement />
          <div className="vert-navbar-scrollable">
            <UserNavbarElement to={`/club/${this.props.clubId}/profile`} />
            <ClubSettingsNavbarElement
              title="Verein"
              iconPrefix="fas"
              iconName="dice-d20"
              selected={this.props.selectedScreen === "club"}
              onClick={this.props.hideMobileNav}
              linkTo={`/club/${this.props.clubId}`}
            />
            <BranchNavbarElement
              title="Kurse"
              iconPrefix="fas"
              iconName="calendar-alt"
              selected={this.props.selectedScreen === "course"}
              onClick={this.props.hideMobileNav}
              linkTo={`/club/${this.props.clubId}/course`}
            />
            {this.context.user && (
              <BranchNavbarElement
                title="Meine Kurse"
                iconPrefix="fas"
                iconName="box-open"
                selected={this.props.selectedScreen === "mycourses"}
                onClick={this.props.hideMobileNav}
                linkTo={`/club/${this.props.clubId}/mycourses`}
              />
            )}
            {this.props.isAdmin && (
              <BranchNavbarElement
                title="Einstellungen"
                iconPrefix="fas"
                iconName="cogs"
                selected={this.props.selectedScreen === "settings"}
                onClick={this.props.hideMobileNav}
                linkTo={`/club-settings/${this.props.clubId}/appearance`}
              />
            )}
          </div>
        </nav>
      </>
    );
  }
}
